import { WidgetT } from 'lib-shared-legacy-types';

import type { ChatWidget } from '../reducers/sections/chatWidgets';

export type ChatWidgetAction =
  | CreateWidget
  | CreateWidgetSucceeded
  | CreateWidgetFailed
  | ReadWidgets
  | ReadWidgetsSucceeded
  | ReadWidgetsFailed
  | ReadWidget
  | ReadWidgetSucceeded
  | ReadWidgetFailed
  | UpdateWidget
  | UpdateWidgetSucceeded
  | UpdateWidgetFailed
  | DeleteWidget
  | DeleteWidgetSucceeded
  | DeleteWidgetFailed
  | AddNewWidget
  | AddNewWidgetSucceeded
  | WidgetChangeName
  | HideChatWidgetModal
  | ShowDeleteWidgetModal
  | HideDeleteWidgetModal
  | ValidateWidgetName
  | ValidateWidgetQueue
  | WidgetChangeQueue;

type Dispatch = (a: ChatWidgetAction) => any;

type AddNewWidget = {
  type: 'CHAT_ADD_NEW_WIDGET';
};

type AddNewWidgetSucceeded = {
  type: 'CHAT_ADD_NEW_WIDGET_SUCCEEDED';
  widget: ChatWidget;
};

type HideChatWidgetModal = {
  type: 'CHAT_HIDE_CHAT_WIDGET_MODAL';
};

type ShowDeleteWidgetModal = {
  type: 'CHAT_SHOW_DELETE_WIDGET_MODAL';
  widget: ChatWidget;
};

type HideDeleteWidgetModal = {
  type: 'CHAT_HIDE_DELETE_WIDGET_MODAL';
};

type ValidateWidgetName = {
  type: 'VALIDATE_WIDGET_NAME';
  error: string | null;
};

type ValidateWidgetQueue = {
  type: 'VALIDATE_WIDGET_QUEUE';
  error: string | null;
};

type WidgetChangeName = {
  type: 'WIDGET_CHANGE_NAME';
  name: string;
};

type WidgetChangeQueue = {
  type: 'WIDGET_CHANGE_QUEUE';
  queueId: string;
};

export function changeName(name: string) {
  return (dispatch: Dispatch) => {
    if (name.trim().length > 2) {
      dispatch({ type: 'VALIDATE_WIDGET_NAME', error: null });
    }
    dispatch({
      type: 'WIDGET_CHANGE_NAME',
      name: name,
    });
  };
}

export function changeQueue(queueId: string) {
  return (dispatch: Dispatch) => {
    if (queueId !== null && queueId !== 'null') {
      dispatch({ type: 'VALIDATE_WIDGET_QUEUE', error: null });
    }
    dispatch({
      type: 'WIDGET_CHANGE_QUEUE',
      queueId: queueId,
    });
  };
}

export function addNewWidget() {
  return (dispatch: Dispatch) => dispatch({ type: 'CHAT_ADD_NEW_WIDGET' });
}

export function hideChatWidgetModal() {
  return (dispatch: Dispatch) =>
    dispatch({ type: 'CHAT_HIDE_CHAT_WIDGET_MODAL' });
}

export function showDeleteWidgetModal(widget: ChatWidget) {
  return (dispatch: Dispatch) =>
    dispatch({
      type: 'CHAT_SHOW_DELETE_WIDGET_MODAL',
      widget: widget,
    });
}

export function hideDeleteWidgetModal() {
  return (dispatch: Dispatch) =>
    dispatch({ type: 'CHAT_HIDE_DELETE_WIDGET_MODAL' });
}

// CRUD
type CreateWidget = {
  type: 'CHAT_CREATE_WIDGET';
  widget: ChatWidget;
};

type CreateWidgetSucceeded = {
  type: 'CHAT_CREATE_WIDGET_SUCCEEDED';
  localWidget: ChatWidget;
  widget: ChatWidget;
};

type CreateWidgetFailed = {
  type: 'CHAT_CREATE_WIDGET_FAILED';
  widget: ChatWidget;
  error: string;
};

type ReadWidgets = {
  type: 'CHAT_READ_WIDGETS';
  payload: any;
};

type ReadWidgetsSucceeded = {
  type: 'CHAT_READ_WIDGETS_SUCCEEDED';
  widgets: Array<ChatWidget>;
  meta: any;
};

type ReadWidgetsFailed = {
  type: 'CHAT_READ_WIDGETS_FAILED';
  error: string;
};

type ReadWidget = {
  type: 'CHAT_READ_WIDGET';
  widgetId: string;
};

type ReadWidgetSucceeded = {
  type: 'CHAT_READ_WIDGET_SUCCEEDED';
  widget: ChatWidget;
};

type ReadWidgetFailed = {
  type: 'CHAT_READ_WIDGET_FAILED';
  error: string;
};

type UpdateWidget = {
  type: 'CHAT_UPDATE_WIDGET';
  data: any;
  id: any;
};

type UpdateWidgetSucceeded = {
  type: 'CHAT_UPDATE_WIDGET_SUCCEEDED';
  widget: ChatWidget;
  widgetId: any;
};

type UpdateWidgetFailed = {
  type: 'CHAT_UPDATE_WIDGET_FAILED';
  error: string;
};

type DeleteWidget = {
  type: 'CHAT_DELETE_WIDGET';
  widget: ChatWidget;
  index: number;
};

type DeleteWidgetSucceeded = {
  type: 'CHAT_DELETE_WIDGET_SUCCEEDED';
  widget: ChatWidget;
};

type DeleteWidgetFailed = {
  type: 'CHAT_DELETE_WIDGET_FAILED';
  error: string;
  index: number;
  widget: ChatWidget;
};

export function createWidget(widget: WidgetT) {
  if (widget.name.trim().length <= 2) {
    return (dispatch: Dispatch) => {
      dispatch({
        type: 'VALIDATE_WIDGET_NAME',
        error: 'Please add a name',
      });
    };
  }

  if (
    widget.queue_id === undefined ||
    widget.queue_id === null ||
    widget.queue_id === '' ||
    widget.queue_id === 'null'
  ) {
    return (dispatch: Dispatch) => {
      dispatch({
        type: 'VALIDATE_WIDGET_QUEUE',
        error: 'Please select a queue',
      });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch({
      type: 'CHAT_CREATE_WIDGET',
      widget: widget,
    });
  };
}

export function validateWidgetName(name: string | null) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'VALIDATE_WIDGET_NAME',
      error: 'Please add a name',
    });
  };
}

export function readWidgets(payload: any) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'CHAT_READ_WIDGETS',
      payload: payload,
    });
  };
}

export function readWidget(widgetId: string) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'CHAT_READ_WIDGET',
      widgetId: widgetId,
    });
  };
}
/**
 * Builds the data object for the update of a widget.
 *
 * @param {ChatWidget} widget A widget object.
 * @returns {object} Dispatch type "CHAT_UPDATE_WIDGET", data object.
 */
export function updateWidget(widget: ChatWidget) {
  if (widget.id === undefined || widget.id === null) {
    console.warn(
      'actions creator updateWidget(widget) no id given. Given widget.id = ',
      widget.id,
    );
    return undefined;
  }
  const data: {
    updates: { name?: string; agent_name_template?: string | null };
  } = {
    updates: {},
  };
  if (widget.name !== undefined) {
    data.updates.name = widget.name;
  }
  if ((widget as any).agent_name_template !== undefined) {
    data.updates.agent_name_template = (widget as any).agent_name_template;
  }
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'CHAT_UPDATE_WIDGET',
      data: data,
      id: widget.id,
    });
  };
}

export function deleteWidget(index: number, widget: ChatWidget) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'CHAT_DELETE_WIDGET',
      widget: widget,
      index: index,
    });
  };
}
